/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_ExpandInputs */

const en_ui_expand = /** @type {(inputs: Ui_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand`)
};

/** @type {(inputs: Ui_ExpandInputs) => LocalizedString} */
const ar_ui_expand = en_ui_expand;

/** @type {(inputs: Ui_ExpandInputs) => LocalizedString} */
const he_ui_expand = en_ui_expand;

/** @type {(inputs: Ui_ExpandInputs) => LocalizedString} */
const ur_ui_expand = en_ui_expand;

/** @type {(inputs: Ui_ExpandInputs) => LocalizedString} */
const es_ui_expand = en_ui_expand;

/** @type {(inputs: Ui_ExpandInputs) => LocalizedString} */
const fr_ui_expand = en_ui_expand;

/** @type {(inputs: Ui_ExpandInputs) => LocalizedString} */
const de_ui_expand = en_ui_expand;

/** @type {(inputs: Ui_ExpandInputs) => LocalizedString} */
const pt_ui_expand = en_ui_expand;

/** @type {(inputs: Ui_ExpandInputs) => LocalizedString} */
const hi_ui_expand = en_ui_expand;

/** @type {(inputs: Ui_ExpandInputs) => LocalizedString} */
const bn_ui_expand = en_ui_expand;

/**
* | output |
* | --- |
* | "Expand" |
*
* @param {Ui_ExpandInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_expand = /** @type {((inputs?: Ui_ExpandInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_ExpandInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_expand(inputs)
	if (locale === "he") return he_ui_expand(inputs)
	if (locale === "ur") return ur_ui_expand(inputs)
	if (locale === "es") return es_ui_expand(inputs)
	if (locale === "fr") return fr_ui_expand(inputs)
	if (locale === "de") return de_ui_expand(inputs)
	if (locale === "pt") return pt_ui_expand(inputs)
	if (locale === "hi") return hi_ui_expand(inputs)
	if (locale === "bn") return bn_ui_expand(inputs)
	return /** @type {LocalizedString} */ ("Expand")
});